import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyBHk58C0lF3cHQ92y4TkEG-wgkruYpTa0k",
  authDomain: "whatsapp-chatgpt-507fc.firebaseapp.com",
  projectId: "whatsapp-chatgpt-507fc",
  storageBucket: "whatsapp-chatgpt-507fc.firebasestorage.app",
  messagingSenderId: "1003430166793",
  appId: "1:1003430166793:web:50f96f85330e7f67f613d8"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
